let Backbone = require("backbone");
let PaymentModel = require("../model/PaymentModel.js");

let main = function (Backbone, PaymentModel) {
    return Backbone.Collection.extend({
        model: PaymentModel
    });
};

let exportedValue = main(Backbone, PaymentModel);
module.exports = exportedValue;



// WEBPACK FOOTER //
// ./src/collection/PaymentCollection.js